export const DiagonalArrowIcon = ({
  className = "w-9 h-9",
  color = "white",
}) => (
  <svg
    className={className}
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.5116 10.2426L4.69189 36.0624L0.449265 31.8198L26.269 6H3.51172V0H36.5116V33H30.5116V10.2426Z"
      fill={color}
    />
  </svg>
);
